import React, { useState } from 'react';
import ArticleContainer from '@/containers/article-detail';
import { ArticleDetailPageType } from '@/containers/article-detail/constants';
import { Framework } from '@/pages/layouts';
import EssayContainer from '@/containers/essay-detail';
import styles from './index.scss';

const Essay = () => {
  const [showArticle, setShowArticle] = useState(false);
  const handleNoEssay = () => {
    setShowArticle(true);
  };

  return (
    <Framework className={styles.Essay}>
      {!showArticle ? (
        <EssayContainer onNoEssay={handleNoEssay} />
      ) : (
        <ArticleContainer
          type={ArticleDetailPageType.Normal}
          onlyContent={true}
        />
      )}
    </Framework>
  );
};

export default Essay;
